import React from 'react';

const Breadcrumbs = ({ selectedPath }) => {
  if (!selectedPath) return null;

  const parts = selectedPath.split('/').filter(Boolean);

  return (
    <div className="vibe-breadcrumbs d-flex align-items-center px-3 py-1 border-bottom small text-muted">
      {parts.map((part, index) => {
        const isLast = index === parts.length - 1;
        return (
          <span key={`${part}-${index}`} className="d-flex align-items-center">
            {index > 0 ? <span className="mx-1">/</span> : null}
            <span className={isLast ? 'text-body font-weight-bold' : ''}>{part}</span>
          </span>
        );
      })}
    </div>
  );
};

export default Breadcrumbs;
